import React from 'react';
import { motion } from 'framer-motion';
import { processData } from '../data/mock';

const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-28 lg:py-36 overflow-hidden"
      style={{ backgroundColor: '#0b1120' }}
    >
      {/* Orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-violet-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-fuchsia-500/10 rounded-full blur-3xl" />
      <div className="absolute inset-0 bg-grid bg-grid-fade opacity-30" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16 lg:mb-20">
          <span className="inline-block text-xs font-bold uppercase tracking-[0.22em] text-sky-300 mb-5">
            Folyamat
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[3.25rem] font-semibold text-white leading-[1.05] tracking-tight text-balance" data-testid="process-title">
            Tiszta út a sikeres indulásig
          </h2>
          <p className="mt-4 text-lg text-slate-400">
            5 jól átlátható lépésben a koncepciótól az eredményekig.
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting gradient line - desktop */}
          <div className="hidden lg:block absolute top-[54px] left-0 right-0 h-px bg-gradient-to-r from-transparent via-violet-500/40 to-transparent" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 lg:gap-5">
            {processData.map((step, index) => (
              <motion.div
                key={step.step}
                data-testid={`process-step-${step.step}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-60px' }}
                transition={{ duration: 0.7, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
                className="relative group"
              >
                {/* Step number badge */}
                <div className="relative z-10 flex justify-center lg:justify-start">
                  <div className="w-[56px] h-[56px] rounded-2xl bg-gradient-to-br from-violet-600 to-fuchsia-500 flex items-center justify-center ring-4 ring-[#0b1120] shadow-[0_10px_30px_-10px_rgba(217,70,239,0.6)] transition-transform duration-500 group-hover:-translate-y-1">
                    <span className="font-display text-xl font-semibold text-white">
                      0{step.step}
                    </span>
                  </div>
                </div>

                {/* Card */}
                <div className="relative mt-6 glass rounded-2xl p-5 lg:p-6 h-[calc(100%-76px)] hover:border-violet-500/40 transition-all duration-500 overflow-hidden">
                  <div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition-opacity duration-500 bg-gradient-to-br from-violet-500/10 to-transparent" />
                  <h3 className="relative font-display text-base lg:text-lg font-semibold text-white mb-2 tracking-tight text-center lg:text-left">
                    {step.title}
                  </h3>
                  <p className="relative text-slate-400 text-sm leading-relaxed text-center lg:text-left">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
